export const validationMessages = {
  employmentStatus: `Hmm, looks like we’re missing something. Can you choose your employment status then try again?`,
  employerName: `Ah, that didn’t work. Fill in your employer’s name using only letters, spaces, hyphens and dashes.`,
  employmentStartDate: `Hmm, that date doesn’t seem right. Can you double check you’ve used the format MM YYYY then try again?`,
  employerOwnName: `If you trade under your own name, we only need your first and last name. Please remove your title then try again.`,
  unemployedStatus: `Based on your employment status we are unable to offer you a personal loan`,
  employmentJobLevel: `Hmm, looks like we’re missing something. Can you choose your employment job level then try again?`,
  employmentIndustry: `Hmm, looks like we’re missing something. Can you choose your employment industry then try again?`,
  mortgageExpense:
    'Ah, that didn’t work. Enter your monthly mortgage or rent payment, using numbers only, then try again.',
  grossAnnualIncome:
    'Ah, that didn’t work. Enter your annual income, using numbers only, then try again.',
  netMonthlyIncome:
    'Ah, that didn’t work. Let us know how much goes into your account using numbers only. Just a heads up – your household income must be greater than or equal to your annual income.',
  financialCircumstances:
    'Hmm, looks like we’re missing something. Can you let us know if your income is likely to go down then try again?',
  earnIncome:
    'Ah, that didn’t work. Enter how much you’ll earn a year, using numbers only, then try again.'
};
